<template>
    <b-overlay
        :show="saving"
        spinner-variant="primary"
        blur=".3"
        opacity=".75"
        rounded="sm"
        class="">
        <validation-observer ref="SubmissionForm">
            <b-form @submit.prevent="onSubmit" class="d-flex justify-content-between gap-10 align-items-center">
                <validation-provider
                    #default="{ errors }"
                    name="Select Banknote"
                    rules="required"
                    class="w-100"
                >
                    <b-form-group
                        label="Select Banknote:"
                        label-for="banknote"
                    >
                        <v-select
                            :reduce="option => option.id"
                            :options="options"
                            @input="form.valid = false"
                            :state="errors.length > 0 ? false : null"
                            :label="'sku'"
                            :class="errors.length > 0 ? 'border-danger-for-v-select' : ''"
                            v-model="form.tap_banknote_id"
                            class="select-style"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                </validation-provider>
                <validation-provider
                    #default="{ errors }"
                    name="Serial Number"
                    rules="required"
                    class="w-100"
                >
                    <b-form-group
                        label="Serial Number:"
                        label-for="serial_number"
                    >
                        <b-form-input
                            id="serial_number"
                            v-model="form.serial_number"
                            class="input-style"
                            @input="form.valid = false"
                            :state="errors.length > 0 ? false : null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                </validation-provider>
                <b-button type="submit" style="margin-top: 10px;" variant="primary" class=""> Save</b-button>
            </b-form>
        </validation-observer>
    </b-overlay>
</template>

<script>

export default {
    name: "SubmissionForm",
    props: ['options', 'form'],
    data() {
        return {
            saving: false
        }
    },
    methods: {
        onSubmit() {
            this.$refs.SubmissionForm.validate().then(success => {
                if (success) {
                    this.saving = true
                    this.form.valid = false
                    $.ajax({
                        method: "POST",
                        url: '/api/tap/check-serial-number',
                        data: this.form,
                    })
                        .then(res => {

                            this.form.valid = true
                            localStorage.setItem('banknote_submission_product_id', res.data.banknote_submission_product_id)
                            this.$successNotify(res.message);
                        })
                        .catch((xhr) => {
                          this.$errorNotify(xhr.responseJSON.message)
                        })
                        .always(() => {
                            this.saving = false
                            this.$emit('storeTap')
                        });
                }
            })
        }
    }
}
</script>

<style>
.input-style, .select-style div {
    height: 40px;
    border-color: #C2C2C2;
    background: transparent
}


.gap-10 {
    gap: 10px;
}
</style>
